import React from 'react';

export const EditorLeftPanelContext = React.createContext(null);
